import SlickSlider from 'react-slick';
import { useRef } from 'react';

import Image from 'library/components/image';
import {
  SlickSliderContainer,
  Icon,
  ImageContainer,
  Slide,
  OverlayImage,
  OverlayActions,
  ActionLike,
  ActionDelete,
} from './styles';

const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    >
      <Icon className="icon-arrow-right" />
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={(e) => {
        // console.log(e);
        onClick(e);
      }}
    >
      <Icon className="icon-arrow-left" />
    </div>
  );
};

const carouselSettings = {
  dots: false,
  infinite: false,
  speed: 400,
  slidesToShow: 3,
  slidesToScroll: 1,
  useTransform: false,
  variableWidth: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

// eslint-disable-next-line max-len
const ImageSlide = ({
  item,
  config: {
    onItemClick, onItemRemove, onItemLike, ...restConfig
  },
}) => {
  const img = useRef(null);

  const handleLike = () => {
    onItemLike(item.id);
  };

  return (
    <Slide
      {...restConfig}
      key={item.id}
    >
      <ImageContainer
        onClick={onItemClick && !restConfig.isEditable ? () => onItemClick(item.id, {
          width: img.current.width,
          height: img.current.height,
          url: item.url,
        }) : undefined}
        isEditable={restConfig?.isEditable}
      >
        {
          onItemClick
            ? (
              <OverlayImage>
                <Icon className="icon-magnifier-add" />
              </OverlayImage>
            ) : null
        }
        {restConfig.isEditable && (
          <OverlayActions>
            <ActionLike active={item.isPrimary} onClick={!item?.imageOwnsId ? undefined : handleLike} disabled={!item?.imageOwnsId}>
              <Icon className={item.isPrimary ? 'icon-star-filled' : 'icon-star'} />
            </ActionLike>
            <ActionDelete active onClick={() => onItemRemove(item.id)}>
              <Icon className="icon-trash" />
            </ActionDelete>
          </OverlayActions>
        )}
        <Image id={item.id} imgRef={img} source={item} isNew={item.isNew} isEditable={restConfig?.isEditable} />
      </ImageContainer>
    </Slide>
  );
};

const Slider = ({ data = [], ...config }) => (
  <SlickSliderContainer>
    <SlickSlider {...carouselSettings}>
      {data.map((item) => <ImageSlide key={item.id} item={item} config={config} />)}
    </SlickSlider>
  </SlickSliderContainer>
);

export default Slider;
